// extracted by mini-css-extract-plugin
export var actionButton = "_kw-0";
export var actionMenuContainer = "_kw-i";
export var bubble = "_kw-2";
export var bubbleActionMenu = "_kw-j";
export var bubbleContext = "_kw-6";
export var bubbleItems = "_kw-7";
export var customer = "_kw-3";
export var divider = "_kw-8";
export var fileList = "_kw-9";
export var hiddenComment = "_kw-o";
export var infoAbove = "_kw-a";
export var internal = "_kw-4";
export var lightActionButton = "_kw-1";
export var link = "_kw-b";
export var merchant = "_kw-5";
export var message = "_kw-c";
export var profilePicture = "_kw-e";
export var quillToolbarContainer = "_kw-f";
export var senderDate = "_kw-g";
export var senderDateCustomer = "_kw-h";
export var senderName = "_kw-d";
export var time = "_kw-k";
export var uploadedImage = "_kw-l";
export var username = "_kw-m";
export var xsmall = "_kw-n";